import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import ItemList from 'flarum/common/utils/ItemList';
import BountyOption from './BountyOption';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class ChooseBountyAmount extends Modal {
  productId = '';
  loading = true;
  oninit(vnode) {
    super.oninit(vnode);
    this.productId = this.attrs.product;
    this.for = this.attrs.for;
    app.request({
      url: app.forum.attribute('apiUrl') + '/floxum-products?filter[for]=bounty&filter[id]=' + this.productId,
      method: 'GET'
    }).then(response => {
      const products = response.data || [];
      this.product = products[0];
      this.price = this.product.attributes.prices[0];
      this.loading = false;
      m.redraw();
    });
  }
  className() {
    return 'PaymentOptionsModal Modal';
  }
  title() {
    return app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.title');
  }
  options() {
    const amounts = [25, 50, 100, 'other'];
    const options = new ItemList();
    amounts.forEach(price => {
      options.add(String(price), m(BountyOption, {
        currency: this.price.cost.replace('0.00', ''),
        amount: price,
        product: this.product,
        for: this.for
      }));
    });
    return options;
  }
  content() {
    return this.loading ? m(LoadingIndicator, null) : m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("p", {
      className: "helpText"
    }, app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.description', {
      subject: this.for.title()
    })), this.options().toArray()));
  }
}
flarum.reg.add('floxum-payments', 'forum/Discussion/ChooseBountyAmount', ChooseBountyAmount);